import type { LearningProgress } from '@/domain/precon-supporter/learning-progress';
import type { LearningProgressRepository } from '@/domain/precon-supporter/learning-progress';
import { CourseId } from '@/domain/precon-supporter/value-objects';

/**
 * 学習進捗取得ユースケース
 */
export class GetLearningProgressUseCase {
  constructor(private learningProgressRepository: LearningProgressRepository) {}

  /**
   * 特定のコースの学習進捗を取得
   */
  async execute(params: {
    courseId: CourseId;
  }): Promise<LearningProgress | null> {
    return await this.learningProgressRepository.findByCourseId(
      params.courseId
    );
  }

  /**
   * すべての学習進捗を取得
   */
  async executeAll(): Promise<LearningProgress[]> {
    return await this.learningProgressRepository.findAll();
  }
}
